export const getRulaCategories = function() {
    return [
        'hotel',
        'gpx',
        'route',
        'maps',
        'baggageTag',
        'voucher',
        'arrival',
        'otherDocuments',
        'otherPartnerInfo',
    ];
}

export const isCategoryFilled = function (category) {
    return category.onSite === true || category.files.length > 0 || category.notAvailable === true;
}

export const isCategoryAvailable = function (category) {
    return category.onSite !== true && category.notAvailable !== true;
}

export const getMissingCategories = function (meta) {
    let missing = [];

    let categories = getRulaCategories();

    // No meta -> all are missing
    if(
        null === meta ||
        false === Object.prototype.hasOwnProperty.call(meta, 'documents')
    ) {
        return categories;
    }

    for(let i = 0, il = categories.length; i < il; i++) {
        let categoryMissing = true;
        for(let j = 0, jl = meta.documents.length; j < jl; j++) {
            if(
                meta.documents[j].category === categories[i] &&
                isCategoryFilled(meta.documents[j])
            ) {
                categoryMissing = false;
                break;
            }
        }

        if(
            true === categoryMissing
        ) {
            missing.push(categories[i]);
        }
    }

    return missing;
}

export const getAvailableCategories = function (meta) {
    let available = [];

    let categories = getRulaCategories();

    // No meta -> all are missing
    if(
        null === meta ||
        false === Object.prototype.hasOwnProperty.call(meta, 'documents')
    ) {
        return categories;
    }

    for(let i = 0, il = categories.length; i < il; i++) {
        let categoryAvailable = true;
        for(let j = 0, jl = meta.documents.length; j < jl; j++) {
            if(
                meta.documents[j].category === categories[i] &&
                !isCategoryAvailable(meta.documents[j])
            ) {
                categoryAvailable = false;
                break;
            }
        }

        if(
            true === categoryAvailable
        ) {
            available.push(categories[i]);
        }
    }

    return available;
}
